import { Controller } from "@hotwired/stimulus"

// Automatically removes an element after a configurable delay.
// Usage: data-controller="auto-dismiss" data-auto-dismiss-delay-value="3000"
export default class extends Controller {
  static values = { delay: { type: Number, default: 3000 } }

  connect() {
    this._timeout = setTimeout(() => {
      this.element.classList.add("opacity-0", "transition-opacity", "duration-500")
      setTimeout(() => this.element.remove(), 500)
    }, this.delayValue)
  }

  disconnect() {
    clearTimeout(this._timeout)
  }
}
